module.exports = __webpack_public_path__ + "img/good-session-6.ff7f5fdb.png";